export default {
    RANGE_CONNECT: 1,
    CLUB_CHAT: 1,
    RANGE_BOOTH: 2,
    WEB_CHAT: 4
};
